
import { getStandardReturnOrderApi, StandardReturnOrderApiParameter, StandardReturnResult, UpdateStandardReturnStateParameter } from "@dana/Services/DanaStandardReturnOrderService";
import updateStep from "@dana/Store/Data/StandardReturns/Handlers/UpdateCurrentStepHandler";
import { DanaStandardReturnOrderActions } from "@dana/Store/Data/StandardReturns/Reducers/GetStandardReturnOrderReducer";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet
} from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type StandardReturnOrderParameter = {
    orderNumber: string;
} & HasOnSuccess<StandardReturnResult> &
    HasOnError<string>;

type HandlerType = ApiHandlerDiscreteParameter<StandardReturnOrderParameter, StandardReturnOrderApiParameter, StandardReturnResult, DispatchProp<DanaStandardReturnOrderActions>>;
export const StandardReturnInit: HandlerType = props => {
    props.dispatch?.({
        type: "StandardReturn/Init",
    });
}
export const SetLoadingTrue: HandlerType = props => {
    props.dispatch?.({
        type: "StandardReturn/IsLoading",
        isLoading: true,
    });
}

export const SendDataToApi: HandlerType = async props => {

    try {
        props.apiResult = await getStandardReturnOrderApi({
            orderNumber: props.parameter.orderNumber,
        });
    } catch (error) {
        if (error.status === 404 || error.status === 403) {
            props.parameter.onError?.(error.errorMessage);
            return;
        }
        throw error;
    }

};

export const PopulateFacetResult: HandlerType = props => {
    if (props.apiResult) {
        props.dispatch?.({
            type: "StandardReturn/PopulateResult",
            data: props.apiResult,
        } as any);
    }
}
export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);

};
export const SetLoadingFalse: HandlerType = props => {
    props.dispatch?.({
        type: "StandardReturn/IsLoading",
        isLoading: false,
    });
}
export const chain = [StandardReturnInit, SetLoadingTrue, SendDataToApi, PopulateFacetResult, ExecuteOnSuccessCallback, SetLoadingFalse];

const getStandardReturnOrder = createHandlerChainRunner(chain, "GetStandardReturnOrder");
export default getStandardReturnOrder;